import {Button, Row, Table} from "antd";
import {examOutService} from "api";
import React, {useEffect, useState} from "react";
import {columns} from "./config";
import {
  formatDateToString,
  randomId,
  removeDuplicateItemsInArray,
  removeItemFromArray,
  removeItemsFromArray,
  toArray,
} from "helper/common";
import {FORMAT_TIME} from "types/enums";
const PrescriptionHistoryModal = props => {
  const {idPhieuKham, setDonThuocLichSu, closeModal} = props;
  const [data, setData] = useState<any>();
  const [listThuocLichSu, setListThuocLichSu] = useState<any[]>([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  useEffect(() => {
    const getLichSuDonThuoc = async id => {
      try {
        const res = await examOutService.getLichSuDonThuoc(id);
        let _listThuoc = [];
        res?.forEach(e => {
          console.log(e);
          console.log(_listThuoc);
          _listThuoc = _listThuoc.concat([
            ...e?.donThuocDto?.thuocs,
            ...e?.donThuocPhuDto?.thuocs,
          ]);
        });
        setListThuocLichSu(_listThuoc);
        setData([...toArray(res)]);
      } catch (error) {}
    };
    getLichSuDonThuoc(idPhieuKham);
  }, [idPhieuKham]);

  const onSelectAll = (selected, selectedRows, changeRows) => {
    const selectedRowKeys = selectedRows?.map(e => e?.key);
    if (selected) {
      setSelectedRowKeys(
        removeDuplicateItemsInArray([...selectedRowKeys, ...selectedRowKeys])
      );
    } else {
      setSelectedRowKeys(
        removeItemsFromArray(selectedRowKeys, selectedRowKeys)
      );
    }
  };
  const onSelect = (record, selected, selectedRows) => {
    console.log(selectedRows);
    if (!selected) {
      console.log(removeItemFromArray(selectedRowKeys, record?.key));
      setSelectedRowKeys(removeItemFromArray(selectedRowKeys, record?.key));
    } else {
      setSelectedRowKeys([...selectedRowKeys, record?.key]);
    }
  };
  useEffect(() => {
    console.log(selectedRowKeys);
  }, [selectedRowKeys]);
  const rowSelection = {
    selectedRowKeys,
    onSelectAll: onSelectAll,
    onSelect: onSelect,
  };
  const submit = () => {
    const donThuocLichSu = listThuocLichSu?.filter(e =>
      selectedRowKeys?.includes(e?.id)
    );
    setDonThuocLichSu(donThuocLichSu?.map(e => ({...e, key: randomId()})));
    closeModal();
  };
  return (
    <div>
      {data &&
        data.map((e, index) => (
          <>
            <div style={{fontWeight: "bold"}}>
              {formatDateToString(e?.ngayKe, FORMAT_TIME.dayFull)}
            </div>
            <Table
              rowSelection={rowSelection}
              dataSource={[
                ...toArray(e?.donThuocDto?.thuocs),
                ...toArray(e?.donThuocPhuDto?.thuocs),
              ]?.map(e => ({...e, key: e?.id}))}
              columns={columns as any}
              bordered
            ></Table>
          </>
        ))}
      <Row justify={"end"}>
        <Button type="primary" onClick={submit}>
          Lấy đơn thuốc
        </Button>
      </Row>
    </div>
  );
};
export default PrescriptionHistoryModal;
